<template>
  <AuthContainer>
    <div class="flex justify-center p-4 mb-4">
      <a href="https://converdy.com">
        <img class="h-12" src="../../../assets/logo-icon.svg" />
      </a>
    </div>

    <Surface>
      <SurfaceContent class="p-8">
        <div class="text-center">
          <Typography class="mb-8" variant="headingTwo">
            Log in to Converdy
          </Typography>

          <Button
            :loading="loading == 'google'"
            @click="googleLogin"
            fullwidth
            class="mt-4"
            color="primary"
            size="large"
            style="background: #de5246"
          >
            <i class="fab fa-google mr-2"></i>
            Continue with Google
          </Button>
          <Button
            :loading="loading == 'facebook'"
            @click="facebookLogin"
            fullwidth
            class="mt-4"
            color="primary"
            size="large"
            style="background: #4267b2"
          >
            <i class="fab fa-facebook-f mr-2"></i>

            Continue with Facebook
          </Button>

          <Divider class="mt-8 mb-6" />

          <a
            class="text-primary cursor-pointer text-center"
            v-if="!emailChoice"
            @click="emailChoice = true"
            >Continue with email <Icon name="arrow-right text-sm ml-2"></Icon
          ></a>
        </div>

        <form
          v-if="emailChoice"
          @submit.prevent="request"
          class="overflow-hidden mt-4"
        >
          <InputField
            fullWidth
            class="mb-4"
            label="Email"
            v-model="email"
            :required="true"
            tabindex="1"
          />

          <div class="flex justify-between">
            <Label class="block mb-2">Password</Label>
            <Link class="text-sm" :to="{name: 'reset-email'}" tabindex="3">
              Forgot your password?
            </Link>
          </div>
          <Input
            fullWidth
            class="mb-4"
            type="password"
            v-model="password"
            :required="true"
            tabindex="2"
          />

          <Alert v-if="message">
            {{ message }}
          </Alert>

          <Button
            :loading="loading == 'email'"
            fullwidth
            class="mt-4"
            color="primary"
            size="large"
          >
            Log in
          </Button>
        </form>
      </SurfaceContent>
    </Surface>

    <div class="flex justify-center p-4 text-dull-dark text-sm">
      Don't have an account?
      <a href="/register">Register</a>
      <!-- <Link class="block ml-1" :to="{name: 'register'}">Sign Up</Link> -->
    </div>
  </AuthContainer>
</template>

<script>
import AuthContainer from '@converdy/components/AuthContainer';
import firebase from '@converdy/firebase/firebase';
import auth from '@converdy/firebase/auth';

const googleProvider = new firebase.auth.GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account',
});
const facebookProvider = new firebase.auth.FacebookAuthProvider();
export default {
  components: {
    AuthContainer,
  },
  data() {
    return {
      loading: false,
      valid: true,
      email: '',
      password: '',
      message: '',
      token: this.$route.params.id,
      emailChoice: false,
    };
  },

  methods: {
    async googleLogin(e) {
      e.preventDefault();
      this.loading = 'google';
      auth
        .signInWithPopup(googleProvider)
        .then(() => {})
        .catch((error) => {
          this.message = error.message;
          this.loading = false;
        });
    },
    async facebookLogin(e) {
      e.preventDefault();
      this.loading = 'facebook';
      auth
        .signInWithPopup(facebookProvider)
        .then(() => {})
        .catch((error) => {
          this.message = error.message;
          this.loading = false;
        });
    },
    async request() {
      this.loading = 'email';
      auth
        .signInWithEmailAndPassword(this.email, this.password)
        .then(() => {})
        .catch((error) => {
          this.message = error.message;
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped lang="scss">
.or-devider {
  display: inline-block;
  width: 100%;
  text-align: center;
  position: relative;
  &:before {
    content: '';
    display: block;
    background: #e2e8f0;
    position: absolute;
    top: 30px;
    height: 1px;
    width: 100%;
  }
  &:after {
    content: 'OR';
    color: #2e91fc;
    font-weight: 100;
    padding: 10px 20px;
    display: inline-block;
    background: white;
    position: relative;
    top: 10px;
  }
}
</style>
